import React, { Component } from "react";

export default class PopupEntidadServicioV2 extends Component {


  constructor(props) {
    super(props);
    this.state = {
      disponibles: this.props.disponibles,
      valor: this.props.prueba

    };
  }

  componentDidMount() {

  }


  handleChange = (e) => {
    //var valores = e.servicio;
    this.props.selectorValuePopUp(e, e.paymentServiceName, e.paymentServiceId,e.paymentEntityId, this.props.titulo,e.networkParticipantCode,e.network);

  };

  render(props) {
    var resultado= JSON.parse(JSON.stringify(this.props.disponibles));
    // console.log(resultado);
    return (
      <div className="modal fade" id={this.props.idModal}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row" style={{display:"contents"}}>
                <div className="col-md-5">
                  <img height="150px" width="150px" className="pago-servicio-img-2" src={this.props.imagen} alt="imagen" />
                </div>
                <div className="col-md-7" style={{paddingTop: 20, textAlign: "right"}}> 
                {this.props.titulo}
                </div>
              </div>
            </div>
            <div className="modal-body" style={{minHeight: 50}}>
              <div className="row justify-content-md-center">                
                {resultado.map(elem => 
                  
                  <div className="col-md-6">
                      <div className="btn btn-default btn-block pago-servicio-btn-item" style={{marginTop: 5}} onClick={(e) => { this.handleChange(elem) }}>
                          <p style={{marginBottom: 0, fontWeight: 400}}>{elem.paymentServiceName}</p>
                      </div> 
                  </div>                                  
                )} 
              </div>                
            </div>
            <div className="modal-footer">
              <button className="btn btn-cu-secundary btn-block">
                CERRAR
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

}